import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerticalDots = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2233 17.9424H11.941C11.4778 17.9424 11.0966 18.092 10.7974 18.3912C10.4982 18.6904 10.3486 19.0933 10.3486 19.5999C10.3486 20.1163 10.4982 20.524 10.7974 20.8232C11.0966 21.1224 11.4778 21.2719 11.941 21.2719H12.2233C12.6865 21.2719 13.0653 21.1224 13.3597 20.8232C13.654 20.5288 13.8012 20.1235 13.8012 19.6072C13.8012 19.1005 13.654 18.6952 13.3597 18.3912C13.0653 18.092 12.6865 17.9424 12.2233 17.9424Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2233 10.217H11.941C11.4778 10.217 11.0966 10.3666 10.7974 10.6658C10.4982 10.965 10.3486 11.3679 10.3486 11.8745C10.3486 12.3909 10.4982 12.7986 10.7974 13.0978C11.0966 13.3969 11.4778 13.5465 11.941 13.5465H12.2233C12.6865 13.5465 13.0653 13.3969 13.3597 13.0978C13.654 12.8034 13.8012 12.3981 13.8012 11.8818C13.8012 11.3751 13.654 10.9698 13.3597 10.6658C13.0653 10.3666 12.6865 10.217 12.2233 10.217Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2233 2.49161H11.941C11.4778 2.49161 11.0966 2.6412 10.7974 2.94037C10.4982 3.23954 10.3486 3.64246 10.3486 4.14913C10.3486 4.66544 10.4982 5.07318 10.7974 5.37236C11.0966 5.67153 11.4778 5.82112 11.941 5.82112H12.2233C12.6865 5.82112 13.0653 5.67153 13.3597 5.37236C13.654 5.07801 13.8012 4.67268 13.8012 4.15636C13.8012 3.6497 13.654 3.24437 13.3597 2.94037C13.0653 2.6412 12.6865 2.49161 12.2233 2.49161Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgVerticalDots);
export default ForwardRef;
